import { useEffect, useState } from '../../vendor/react';
import { useWorkspace } from '../workspace/useWorkspace';
import { assignPlan, calculateUsage, closeSupportSession, downloadLicenseFile, ensureOrganizationSubscription, extendTrial, getInstallationId, getPlatformOrganizations, getSaasDatabase, getSubscriptionAccess, hasFeature, issueDevelopmentLocalLicense, reactivateOrganization, saveNotice, savePlan, setActiveEdition, startSupportSession, subscribeSaas, suspendOrganization, verifyAndActivateLocalLicense } from './saas-store';
import type { CommercialFeatureId } from '../../config/commercialPlans';

export function useSaas() {
  const workspace = useWorkspace();
  const [, setVersion] = useState(0);
  const organizationId = workspace.organization?.id ?? '';
  useEffect(() => subscribeSaas(() => setVersion((value) => value + 1)), []);
  useEffect(() => { if (organizationId) { ensureOrganizationSubscription(organizationId); setActiveEdition(organizationId); } }, [organizationId]);
  const platformOrganizations = getPlatformOrganizations();
  useEffect(() => { for (const organization of platformOrganizations) ensureOrganizationSubscription(organization.id); }, [platformOrganizations.map((item)=>item.id).join('|')]);
  const database = getSaasDatabase();
  const access = organizationId ? getSubscriptionAccess(organizationId) : null;
  const usage = organizationId ? calculateUsage(organizationId, workspace.workspace) : null;
  return {
    ...database,
    organizationId,
    subscription: access?.subscription ?? null,
    plan: access?.plan ?? null,
    readOnly: access?.readOnly ?? false,
    blocked: access?.blocked ?? false,
    localOnly: access?.localOnly ?? false,
    usage,
    installationId: getInstallationId(),
    platformOrganizations,
    hasFeature: (feature: CommercialFeatureId) => organizationId ? hasFeature(organizationId, feature) : false,
    actions: { assignPlan, extendTrial, suspendOrganization, reactivateOrganization, savePlan, saveNotice, startSupportSession, closeSupportSession, issueDevelopmentLocalLicense, verifyAndActivateLocalLicense, downloadLicenseFile },
  };
}
